import { render, staticRenderFns } from "./system-reminder.vue?vue&type=template&id=74f02990&scoped=true&"
import script from "./system-reminder.vue?vue&type=script&lang=js&"
export * from "./system-reminder.vue?vue&type=script&lang=js&"
import style0 from "./system-reminder.vue?vue&type=style&index=0&id=74f02990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f02990",
  null
  
)

export default component.exports